
export class MicroappVmsAddressBookUserFilter{
    general: string;
    tenant_id: string = null;
}